let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dP0e2")).then(() => parcelRequire('4uHll'));